import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { EQM1011_R01Dto } from './Dto_EQM1011_R01';

export interface EQM1011_R01Filter {
    compCd: string;
    plcaddressid: number | null;
    baseDate: Date | undefined;
}

export interface Store_EQM1011_R01 {
    EQM1011_R01Filter: EQM1011_R01Filter;
    setEQM1011_R01Filter: (filter: Partial<EQM1011_R01Filter>) => void;

    EQM1011_R01List: EQM1011_R01Dto[];
    setEQM1011_R01List: (list: EQM1011_R01Dto[]) => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;
    scrollTop: number | null;
    setScrollTop: (top: number | null) => void;

    initData: () => void;
}

const createDefaultEQM1011_R01Filter = (): EQM1011_R01Filter => ({
    compCd: '',
    plcaddressid: null,
    baseDate: new Date(),
});

export const defaultEQM1011_R01Filter = createDefaultEQM1011_R01Filter();

export const useEQM1011_R01Store = create<Store_EQM1011_R01>((set) => {
    return {
        EQM1011_R01Filter: createDefaultEQM1011_R01Filter(),
        setEQM1011_R01Filter: (filter) => set((state) => ({
            EQM1011_R01Filter: { ...state.EQM1011_R01Filter, ...filter },
        })),

        EQM1011_R01List: [],
        setEQM1011_R01List: (list) => set({ EQM1011_R01List: list }),

        columnState: null,
        setColumnState: (state) => set({ columnState: state }),
        scrollTop: null,
        setScrollTop: (top) => set({ scrollTop: top }),

        initData: () => set({
            EQM1011_R01Filter: createDefaultEQM1011_R01Filter(),
            EQM1011_R01List: [],
            columnState: null,
            scrollTop: null,
        }),
    };
});
